import ShowRoomsPage from "components/mapPages/showRooms/ShowRoomsPage"

import { extractData, getSeoKey, getShowroomAll, ShowRoom } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import { MapContextProvider } from "components/mapPages/map/MapContext"
import { GetStaticProps } from "next"

type ShowRoomsStaticProps = {
  pageData: ShowRoom[]
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<
  ShowRoomsStaticProps
> = async () => {
  const data = await getShowroomAll(null, null).then(extractData)
  const seoData = await getSeoKey("showRooms")
  const seo = {
    title: seoData.data.body.title,
    description: seoData.data.body.description,
    keywords: seoData.data.body.keywords,
  }
  return {
    props: {
      pageData: data?.body,
      seo: seo,
    },
    revalidate: 60,
  }
}

const ShowRooms = ({ pageData, seo }: ShowRoomsStaticProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <MapContextProvider itemList={pageData}>
        <ShowRoomsPage />
      </MapContextProvider>
    </>
  )
}

export default ShowRooms
